import { gql } from '@apollo/client';
import { UpdateUserInput } from './types';
import { User } from '../../queries/users/types';

/**
 * GraphQL mutation to update an existing user
 */
export const UPDATE_USER = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input) {
      user {
        id
        databaseId
        name
        email
        username
        roles {
          nodes {
            name
          }
        }
      }
    }
  }
`;

export interface UpdateUserData {
  updateUser: {
    user: User;
  };
}

export interface UpdateUserVariables {
  input: UpdateUserInput;
}
